import { render, staticRenderFns } from "./FormUploadPpobProducts.vue?vue&type=template&id=8c393096&scoped=true"
import script from "./FormUploadPpobProducts.vue?vue&type=script&lang=js"
export * from "./FormUploadPpobProducts.vue?vue&type=script&lang=js"
import style0 from "./FormUploadPpobProducts.vue?vue&type=style&index=0&id=8c393096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c393096",
  null
  
)

export default component.exports